import React, { Component } from 'react';
import './Footer.scss';

export default class Footer extends Component {
  render () {
      return (
        <div>
          <footer className="footer">
            <div className="container">
              <div className="row">
                <div className="col-sm-3 col-md-3 d-sm-none d-lg-block">
                  <div className="footer__logo">
                    <a href="https://www.spectrio.com">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 657.78 173.5"><path d="M45.71 75.26c-13.15-2.42-21.18-4.28-21.18-11.22 0-9.32 13.03-10.33 18.6-10.33 8.28-.15 16.42 2.23 23.32 6.82l4.03 2.7 9.2-16.9-3.11-2.1a63.249 63.249 0 00-33.36-8.92c-23.56 0-38.77 11.46-38.77 29.13 0 22.63 20.17 26.18 36.31 29.09 12.75 2.26 20.53 4.03 20.53 10.41 0 2.5 0 10.17-19.28 10.17a49.071 49.071 0 01-28.89-9.2l-3.71-2.78L0 118.55l2.58 2.3c8.07 7.06 23.64 11.82 38.37 11.82 24.85 0 40.34-11.18 40.34-29.13-.12-21.82-19.81-25.41-35.58-28.28zm96.58-40.02a43.73 43.73 0 00-29.65 10.69V35.89H92.99V173.5h20.17v-51.2a43.475 43.475 0 0029.13 10.37c27.72 0 47.81-20.53 47.81-48.82s-20.09-48.61-47.81-48.61zm-.81 18.64c16.46 0 28.24 12.63 28.24 29.98s-11.7 29.98-28.24 29.98-28.52-12.1-28.52-29.98 11.74-29.98 28.52-29.98zm100.9-18.64c-27.19 0-46.96 20.45-46.96 48.41s20.62 48.82 50.15 48.82c14.02.62 27.58-5.05 37-15.45l2.26-2.74-12.1-13.96-3.11 3.63A30.434 30.434 0 01245.94 114c-15.49 0-26.79-8.55-29.69-22.11h72.62V84.19c.15-28.94-19.01-48.95-46.49-48.95zm0 18.48c12.7-.48 23.85 8.35 26.3 20.82h-52.45c2.38-12.46 13.49-21.3 26.15-20.82zm101.27.16c8.76-.29 17.06 3.91 22.03 11.13l2.3 3.51 15.61-10.57-2.06-3.39c-7.58-12.47-21.02-19.32-37.88-19.32-28.56 0-49.3 20.45-49.3 48.41s20.74 48.82 49.3 48.82c16.74 0 30.18-6.86 37.84-19.28l2.1-3.43-15.61-10.57-2.3 3.47a25.565 25.565 0 01-22.03 10.97c-17.07 0-29.01-12.1-29.01-29.98s11.94-29.77 29.01-29.77zm95.97 56.88a15.311 15.311 0 01-10.21 3.39c-7.5 0-10.97-3.75-10.97-11.78V54.2h26.67V35.89h-26.63V16.76h-20.17v19.12h-15.65l15.65 18.32v48.82c0 18.56 11.13 29.65 29.77 29.65 7.72.22 15.27-2.35 21.26-7.22l2.38-2.1-8.07-16.14-4.03 3.55zm42.28-66.04v-8.84h-19.65v95.94h20.17V83.05c0-18.15 9-28.24 25.34-28.24h.85c.66.04 1.32.04 1.98 0h4.03V35.24h-4.03a41.88 41.88 0 00-28.69 9.48zM536.21.02c-6.94-.39-12.89 4.91-13.28 11.85-.39 6.94 4.91 12.89 11.85 13.28.47.03.95.03 1.42 0 6.94.39 12.89-4.91 13.28-11.85.39-6.94-4.91-12.89-11.85-13.28-.47-.03-.95-.03-1.42 0zm-10.17 35.87h20.13v95.94h-20.13zm83.07-.65c-26.92-.04-48.77 21.74-48.81 48.66-.04 26.92 21.74 48.77 48.66 48.81 26.92.04 48.77-21.74 48.81-48.66v-.4c.75-25.99-19.71-47.67-45.7-48.42-1-.03-1.98-.02-2.96.01zm0 78.59c-16.74 0-28.44-12.1-28.44-29.98s11.7-29.98 28.44-29.98 28.24 12.35 28.24 29.98-11.54 29.98-28.24 29.98z" /></svg>
                    </a>
                  </div>
                </div>
                <div className="col-12 col-sm-3 col-lg-2">
                  <label>Solutions</label>
                  <div className="custom-menu-class">
                    <ul id="menu-footer-menu-1" className="menu">
                      <li id="menu-item-28547" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28547"><a href="https://www.spectrio.com/solutions/digital-signage/">Digital Signage</a></li>
                      <li id="menu-item-28546" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28546"><a href="https://www.spectrio.com/solutions/interactive-kiosks/">Interactive Kiosks</a></li>
                      <li id="menu-item-28544" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28544"><a href="https://www.spectrio.com/solutions/wifi-marketing/">Wi-Fi Marketing</a></li>
                      <li id="menu-item-28549" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28549"><a href="https://www.spectrio.com/solutions/overhead-music/">On-Premise Messaging</a></li>
                      <li id="menu-item-28548" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28548"><a href="https://www.spectrio.com/solutions/on-hold-messaging/">On Hold Marketing</a></li>
                      <li id="menu-item-28545" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28545"><a href="https://www.spectrio.com/solutions/scent-marketing/">Scent Marketing</a></li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-sm-3 col-lg-2">
                  <label>Company</label>
                  <div className="custom-menu-class">
                    <ul id="menu-footer-menu-2" className="menu">
                      <li id="menu-item-28551" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28551"><a href="https://www.spectrio.com/company/about-us/">About Spectrio</a></li>
                      <li id="menu-item-28553" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28553"><a href="https://www.spectrio.com/company/contact-us/">Contact Us</a></li>
                      <li id="menu-item-30489" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-30489"><a href="https://recruiting.paylocity.com/recruiting/jobs/All/a12f338a-09a6-4b1d-89eb-5690dc1895ed/SPECTRIO-LLC">Careers</a></li>
                      <li id="menu-item-28550" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28550"><a href="https://www.spectrio.com/acquisitions/">Acquisitions</a></li>
                      <li id="menu-item-28552" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28552"><a href="https://www.spectrio.com/company/community-involvement/">Community Involvement</a></li>
                      <li id="menu-item-28554" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28554"><a href="https://www.spectrio.com/company/testimonials/">Testimonials</a></li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-sm-3 col-lg-2">
                  <label>Resources</label>
                  <div className="custom-menu-class">
                    <ul id="menu-footer-menu-3" className="menu">
                      <li id="menu-item-28556" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-28556"><a href="https://support.spectrio.com/hc/en-us">Knowledge Base</a></li>
                      <li id="menu-item-28557" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28557"><a href="https://www.spectrio.com/resources/">Learning Center</a></li>
                      <li id="menu-item-28561" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28561"><a href="https://www.spectrio.com/company/contact-us/">Customer Support</a></li>
                      <li id="menu-item-28559" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-28559"><a href="https://www.spectrio.com/blog/">Spectrio Blog</a></li>
                      <li id="menu-item-28560" className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-28560"><a href="https://www.spectrio.com/company-news/">Company News</a></li>
                      <li id="menu-item-30490" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-30490"><a href="/apps/">Integrations</a></li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-sm-3 footer__badges">
                  <div className="retro-btn-container smaller">
                    <a href="https://www.spectrio.com/demo/" className="btn btn-primary btn-retro">
                      <span className="btn__text">
                        Sign Up              </span>
                      <span className="btn__icon">
                        <i className="fa fa-chevron-right"></i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <hr />
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-6 col-md-3">
                  <label>Headquarters</label>
                  <address>
                    <p>
                      4033 Tampa Road<br />
                      Suite 103<br />
                      Oldsmar, FL 34677<br />
                    </p>
                    <div className="footer__phone">
                      <a href="tel:tel:18005844653" title="Spectrio Phone Number">
                        <div className="icon-holder d-md-none d-lg-inline-block">
                          <i className="fa fa-phone-square"></i>
                        </div>
                        <span>Tel: 800-584-4653</span>
                      </a>
                    </div>
                    <div className="footer__fax">
                      <a href="tel:17277857659" title="Spectrio Fax Number">
                        <div className="icon-holder d-md-none d-lg-inline-block">
                          <i className="fa fa-fax"></i>
                        </div>
                        <span>Fax: 727-785-7659</span>
                      </a>
                    </div>
                  </address>
                </div>
                <div className="col-12 col-sm-6 col-md-5 col-lg-6">
                  <label>Newsletter</label>
                  <div className="row footer__newsletter">
                    <div id="mc_embed_signup">
                      <form action="https://spectrio.us5.list-manage.com/subscribe/post?u=10c236a2f0d3fcab851c34103&amp;id=50f889560b" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate="">
                        <div id="mc_embed_signup_scroll">
                          <div className="col-12">
                            <div className="email-input">
                              <input id="mce-EMAIL" type="email" value="" name="EMAIL" placeholder="Email Address" required="required" className="email" />
                              <button id="mc-embedded-subscribe" type="submit" value="Subscribe" name="subscribe" className="marketing-btn marketing-btn--orange">
                                <span className="d-block d-md-none d-lg-block">
                                  Subscribe
                                </span>
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className="d-none d-md-block d-lg-none svg-inline--fa fa-chevron-right fa-w-10">
                                  <path data-v-6321e120="" fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" className=""></path>
                                </svg>
                              </button>
                            </div>
                            <div aria-hidden="true" className="hidden-form">
                              <input type="text" name="b_10c236a2f0d3fcab851c34103_50f889560b" tabIndex="-1" value="" />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <p>Sign up for our newsletter to stay up to date with Spectrio!</p>
                  </div>
                </div>
                <div className="col-12 col-md-4 col-lg-3 footer__social-icons">
                  <ul>
                    <li title="facebook" className="footer__social-icons--facebook">
                      <a href="https://www.facebook.com/LikeSpectrio/" aria-label="Spectrio Facebook" title="Spectrio Facebook" rel="noopener">
                        <i className="fab fa-facebook"></i>
                      </a>
                    </li>
                    <li title="linkedin" className="footer__social-icons--linkedin">
                      <a href="https://www.linkedin.com/company/spectrio" aria-label="Spectrio LinkedIn" title="Spectrio LinkedIn" rel="noopener">
                        <i className="fab fa-linkedin"></i>
                      </a>
                    </li>
                    <li title="twitter" className="footer__social-icons--twitter">
                      <a href="https://twitter.com/tweetspectrio" aria-label="Spectrio Twitter" title="Spectrio Twitter" rel="noopener">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-7 order-1 order-sm-2 footer__links">
                  <ul>
                    <li>
                      <a href="https://www.spectrio.com/terms-and-conditions/" className="">
                        Terms of Service
                      </a>
                    </li>
                    <li>
                      <a href="https://www.spectrio.com/privacy-policy/" className="">
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href="https://www.spectrio.com/sitemap.xml.">
                        Sitemap
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-md-5 order-1 order-sm-1 footer__copyright">
                  <p>© 2021 Spectrio, Inc. All rights reserved.</p>
                </div>
              </div>
            </div>
          </footer>
        </div>
      )
   }
}
